import React from 'react';
import { ScheduledMessagesWebSocketProvider } from 'src/context/ScheduledMessagesWebSocketContext';
import ScheduledMessagesViewComponent from 'src/views/management/ScheduledMessagesView/ScheduledMessagesViewComponent';

function ScheduledMessagesView() {
  return (
    <ScheduledMessagesWebSocketProvider>
      <ScheduledMessagesViewComponent />
    </ScheduledMessagesWebSocketProvider>
  );
}

export default ScheduledMessagesView;
